import { put, takeEvery } from "@redux-saga/core/effects";
import {
	handleNotificationAlertCatch,
	handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";
import AxiosCustom from "../../../common/components/apiConfig";

export const actionTypes = {
	selectMemberMaxGoldCreditTable: "[selectMemberMaxGoldCredit ] Action",
	selectMemberMaxGoldCreditLoad:
		"[selectMemberMaxGoldCreditLoad] Action",
	selectMemberMaxGoldCreditAsync:
		"[selectMemberMaxGoldCreditAsync] Action",
};

const initialState = {
	data: [],
	
	loading: false,
};

export const select_member_max_gold_credit_reducer = (
	state = initialState,
	{ type, payload },
) => {
	switch (type) {
		case actionTypes.selectMemberMaxGoldCreditTable:
			return {
				...state,
				data: payload?.data ? payload?.data : [],
			};

		case actionTypes.selectMemberMaxGoldCreditLoad:
			return {
				...state,
				loading: payload,
			};
		default:
			return state;
	}
};

function* handleWorker({ payload }) {
	yield put({
		type: actionTypes.selectMemberMaxGoldCreditLoad,
		payload: payload,
	});
	let config = {
		url: "select_request",
	};

	let data = {
		table: "gold_credit",
		method_type: "select_member_max_gold_credit",
		data: payload?.data ? payload?.data : {},
		sort_by: {},
		size: "50",
		from: "0",
	};

	try {
		let res = yield AxiosCustom(config, data);
		let isOk = handleNotificationAlertTrySelect(res);
		yield put({
			type: actionTypes.selectMemberMaxGoldCreditTable,
			payload: res.data.response,
		});
	} catch {
		handleNotificationAlertCatch();
		// yield put({ type: actionTypes.creaditSelectLoad, payload: false });
	} finally {
		yield put({
			type: actionTypes.selectMemberMaxGoldCreditLoad,
			payload: false,
		});
	}
}

export function* selectMemberMaxGoldCredit() {
	yield takeEvery(actionTypes.selectMemberMaxGoldCreditAsync, handleWorker);
}
